import React from 'react';
import { getLocale } from '@zenlayer/zen-intl18';
/**
 * 生成具有条款链接的文本
 * @function
 * @param {{ name: string; url: string }[]} props.clauses - 包含协议条款的数组，每个条款有 name 和 url 属性
 * @param {Locales} props.locale - 国际化文本语言标识 zh | en
 * @param {boolean} props.historyHasAgreed - 是否同意过协议条款
 * @return {JSX.Element}
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getAgreementText = function getAgreementText(clauses, locale, historyHasAgreed) {
  var _locale = locale || getLocale();

  if (_locale === 'en') {
    return /*#__PURE__*/_jsxs("span", {
      children: [historyHasAgreed ? /*#__PURE__*/_jsx("span", {
        children: "By continuing, you agree to "
      }) : /*#__PURE__*/_jsx("span", {
        children: "I agree to "
      }), clauses.map(function (info, index) {
        if (clauses.length === 1) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("a", {
              href: info.url,
              target: "_blank",
              children: info.name
            }), /*#__PURE__*/_jsx("span", {
              children: " "
            })]
          }, info.name);
        } else {
          if (index < clauses.length - 2) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsx("a", {
                href: info.url,
                target: "_blank",
                children: info.name
              }), /*#__PURE__*/_jsx("span", {
                children: ', '
              })]
            }, info.name);
          } else if (index === clauses.length - 2) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsx("a", {
                href: info.url,
                target: "_blank",
                children: info.name
              }), /*#__PURE__*/_jsx("span", {
                children: ' and '
              })]
            }, info.name);
          } else if (index === clauses.length - 1) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsx("a", {
                href: info.url,
                target: "_blank",
                children: info.name
              }), /*#__PURE__*/_jsx("span", {
                children: " "
              })]
            }, info.name);
          }
        }
      }), /*#__PURE__*/_jsx("span", {
        children: "upon placing the order."
      })]
    });
  } else if (_locale === 'zh') {
    return /*#__PURE__*/_jsxs("span", {
      children: [historyHasAgreed ? /*#__PURE__*/_jsx("span", {
        children: "\u7EE7\u7EED\u4E0B\u4E00\u6B65\u786E\u8BA4\u8BA2\u5355\uFF0C\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F"
      }) : /*#__PURE__*/_jsx("span", {
        children: "\u4E0B\u5355\u65F6\uFF0C\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F"
      }), clauses.map(function (info, index) {
        if (index > 0 && index < clauses.length - 1) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: "\uFF0C"
            }), /*#__PURE__*/_jsx("a", {
              href: info.url,
              target: "_blank",
              children: info.name
            })]
          }, info.name);
        } else if (index > 0 && index === clauses.length - 1) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: "\u548C"
            }), /*#__PURE__*/_jsx("a", {
              href: info.url,
              target: "_blank",
              children: info.name
            })]
          }, info.name);
        } else {
          return /*#__PURE__*/_jsx("a", {
            href: info.url,
            target: "_blank",
            children: info.name
          }, info.name);
        }
      }), /*#__PURE__*/_jsx("span", {
        children: "\u3002"
      })]
    });
  }
};
/**
 * 生成具有条款链接的注册文本
 * @function
 * @param {{ name: string; url: string }[]} props.clauses - 包含协议条款的数组，每个条款有 name 和 url 属性
 * @param {Locales} props.locale - 国际化文本语言标识 zh | en
 * @param {boolean} props.historyHasAgreed - 是否同意过协议条款
 * @return {JSX.Element}
 */

export var getSignupAgreementText = function getSignupAgreementText(clauses, locale, historyHasAgreed) {
  var _locale = locale || getLocale();

  if (_locale === 'en') {
    return /*#__PURE__*/_jsxs("span", {
      children: [historyHasAgreed ? /*#__PURE__*/_jsx("span", {
        children: "By creating an account, you agree to the "
      }) : /*#__PURE__*/_jsx("span", {
        children: "I have read and agree "
      }), clauses.map(function (info, index) {
        if (clauses.length === 1) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("a", {
              href: info.url,
              target: "_blank",
              children: info.name
            }), /*#__PURE__*/_jsx("span", {})]
          }, info.name);
        } else {
          if (index < clauses.length - 2) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsx("a", {
                href: info.url,
                target: "_blank",
                children: info.name
              }), /*#__PURE__*/_jsx("span", {
                children: ', '
              })]
            }, info.name);
          } else if (index === clauses.length - 2) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsx("a", {
                href: info.url,
                target: "_blank",
                children: info.name
              }), /*#__PURE__*/_jsx("span", {
                children: ' and '
              })]
            }, info.name);
          } else if (index === clauses.length - 1) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsx("a", {
                href: info.url,
                target: "_blank",
                children: info.name
              }), /*#__PURE__*/_jsx("span", {})]
            }, info.name);
          }
        }
      }), /*#__PURE__*/_jsx("span", {
        children: "."
      })]
    });
  } else if (_locale === 'zh') {
    return /*#__PURE__*/_jsxs("span", {
      children: [historyHasAgreed ? /*#__PURE__*/_jsx("span", {
        children: "\u521B\u5EFA\u8D26\u6237\u5373\u8868\u793A\u60A8\u540C\u610F"
      }) : /*#__PURE__*/_jsx("span", {
        children: "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F"
      }), clauses.map(function (info, index) {
        if (index > 0 && index < clauses.length - 1) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: "\uFF0C"
            }), /*#__PURE__*/_jsx("a", {
              href: info.url,
              target: "_blank",
              children: info.name
            })]
          }, info.name);
        } else if (index > 0 && index === clauses.length - 1) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: "\u548C"
            }), /*#__PURE__*/_jsx("a", {
              href: info.url,
              target: "_blank",
              children: info.name
            })]
          }, info.name);
        } else {
          return /*#__PURE__*/_jsx("a", {
            href: info.url,
            target: "_blank",
            children: info.name
          }, info.name);
        }
      }), /*#__PURE__*/_jsx("span", {
        children: "\u3002"
      })]
    });
  }
};